module.exports = __webpack_public_path__ + "img/7.60786c10.jpg";